export const SNACKBAR_SUBMISSION = 'SNACKBAR_SUBMISSION';

export const SNACKBAR_SUCCESS = 'success';
export const SNACKBAR_ERROR = 'error';
export const SNACKBAR_WARNING = 'warning';
export const SNACKBAR_INFO = 'info';
